export const userConstants = {
  REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
  REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
  REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

  LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
  LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
  LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

  LOGOUT: 'USERS_LOGOUT',

  UPDATE_USER: 'UPDATE_USER',
  UPDATE_UTM: 'UPDATE_UTM'
};

export const bookingConstants = {
  SESSION_EVENT_BOOKING_REQUEST: 'SESSION_EVENT_BOOKING_REQUEST',
  SESSION_EVENT_BOOKING_SUCCESS: 'SESSION_EVENT_BOOKING_SUCCESS',
  SESSION_EVENT_BOOKING_FAILURE: 'SESSION_EVENT_BOOKING_FAILURE',
  SESSION_EVENT_BOOKING_RESET: 'SESSION_EVENT_BOOKING_RESET'
};

export const filterConstants = {
  SET_FILTER: 'SET_FILTER',
  AREA_FILTER: 'AREA',
  SET_COURTS_FILTERS: 'SET_COURTS_FILTERS'
};

export const routingConstants = {
  SET_SIGN_END_ROUTE: 'SET_SIGN_END_ROUTE',
  SET_SIGN_END_ROUTE_ACTION: 'SET_SIGN_END_ROUTE_ACTION',
  SET_SIGN_CANCEL_ROUTE: 'SET_SIGN_CANCEL_ROUTE',
  SET_PAYMENT_END_ROUTE: 'SET_PAYMENT_END_ROUTE',
  SET_PAYMENT_END_ROUTE_ACTION: 'SET_PAYMENT_END_ROUTE_ACTION'
};

export const modalsConstants = {
  OPEN_MODAL: 'OPEN_MODAL',
  RESET: 'RESET'
};

export const pendingBookingConstants = {
  SET_PENDING_SESSION_EVENT_ID: 'SET_PENDING_SESSION_EVENT_ID',
  SET_PENDING_COURT_EVENT_ID: 'SET_PENDING_COURT_EVENT_ID'
};

export const configConstants = {
  GET_CONFIG_REQUEST: 'GET_CONFIG_REQUEST',
  GET_CONFIG_SUCCESS: 'GET_CONFIG_SUCCESS',
  GET_CONFIG_FAILURE: 'GET_CONFIG_FAILURE',

  APP_INITIALIZED: 'APP_INITIALIZED'
};

export const scrollToConstants = {
  SET_SCROLL_TO_ID: 'SET_SCROLL_TO_ID',
  RESET_SCROLL_TO_ID: 'RESET_SCROLL_TO_ID'
};

export const paymentConstants = {
  SET_PAYMENT_STATUS: 'SET_PAYMENT_STATUS'
};



// WEBPACK FOOTER //
// ./src/utils/types.js